export var Themes;
(function (Themes) {
    Themes["CLAUDE"] = "claude";
    Themes["MAN"] = "man";
    Themes["VWPFS"] = "vwpfs";
    Themes["VW"] = "vw";
    Themes["SEAT"] = "seat";
    Themes["SKODA"] = "skoda";
    Themes["AUDI"] = "audi";
    Themes["DUTCHLEASE"] = "dutchlease";
    Themes["XLLEASE"] = "xllease";
    Themes["XLEASY"] = "xleasy";
    Themes["POLITIE"] = "politie";
})(Themes || (Themes = {}));
export var ThemeVariants;
(function (ThemeVariants) {
    ThemeVariants["BRAND"] = "brand";
    ThemeVariants["CONTRAST"] = "contrast";
    ThemeVariants["SHADED"] = "shaded";
})(ThemeVariants || (ThemeVariants = {}));
/**
 *
 */
export var ThemeBreakpoints;
(function (ThemeBreakpoints) {
    ThemeBreakpoints[ThemeBreakpoints["XS"] = 320] = "XS";
    ThemeBreakpoints[ThemeBreakpoints["SM"] = 768] = "SM";
    ThemeBreakpoints[ThemeBreakpoints["MD"] = 1024] = "MD";
    ThemeBreakpoints[ThemeBreakpoints["LG"] = 1366] = "LG";
    ThemeBreakpoints[ThemeBreakpoints["XL"] = 1367] = "XL";
})(ThemeBreakpoints || (ThemeBreakpoints = {}));
/**
 *
 */
export var ThemePalette;
(function (ThemePalette) {
    ThemePalette["BRAND_ACCENT"] = "brand-accent";
    ThemePalette["BRAND_PRIMARY"] = "brand-primary";
    ThemePalette["BRAND_SECONDARY"] = "brand-secondary";
    ThemePalette["BRAND_TERTIARY"] = "brand-tertiary";
    ThemePalette["CONTRAST_ACCENT"] = "contrast-accent";
    ThemePalette["CONTRAST_PRIMARY"] = "contrast-primary";
    ThemePalette["CONTRAST_SECONDARY"] = "contrast-secondary";
    ThemePalette["CONTRAST_TERTIARY"] = "contrast-tertiary";
    ThemePalette["BRAND_SPECIAL_FIRST"] = "special-brand-first";
    ThemePalette["BRAND_SPECIAL_SECOND"] = "special-brand-second";
    ThemePalette["BRAND_SPECIAL_THIRD"] = "special-brand-third";
    ThemePalette["CONTRAST_SPECIAL_FIRST"] = "special-contrast-first";
    ThemePalette["CONTRAST_SPECIAL_SECOND"] = "special-contrast-second";
    ThemePalette["CONTRAST_SPECIAL_THIRD"] = "special-contrast-third";
})(ThemePalette || (ThemePalette = {}));
export var ThemePaletteShade;
(function (ThemePaletteShade) {
    ThemePaletteShade["LIGHTEST"] = "lightest";
    ThemePaletteShade["VERY_LIGHT"] = "very-light";
    ThemePaletteShade["LIGHT"] = "light";
    ThemePaletteShade["MEDIUM"] = "medium";
    ThemePaletteShade["DARK"] = "dark";
    ThemePaletteShade["VERY_DARK"] = "very-dark";
    ThemePaletteShade["DARKEST"] = "darkest";
})(ThemePaletteShade || (ThemePaletteShade = {}));
/**
 *
 */
export var ThemePaletteState;
(function (ThemePaletteState) {
    ThemePaletteState["DANGER"] = "danger";
    ThemePaletteState["WARNING"] = "warning";
    ThemePaletteState["SUCCESS"] = "success";
    ThemePaletteState["DISABLED"] = "disabled";
})(ThemePaletteState || (ThemePaletteState = {}));
/**
 *
 */
export var ThemeSize;
(function (ThemeSize) {
    ThemeSize["TINY"] = "tiny";
    ThemeSize["SMALL"] = "small";
    ThemeSize["NORMAL"] = "normal";
    ThemeSize["BIG"] = "big";
    ThemeSize["HUGE"] = "huge";
})(ThemeSize || (ThemeSize = {}));
/**
 * TODO(nz,ed): extends ThemeSize?
 */
export var ThemeShadowSizes;
(function (ThemeShadowSizes) {
    ThemeShadowSizes["NONE"] = "none";
    ThemeShadowSizes["TINY"] = "tiny";
    ThemeShadowSizes["SMALL"] = "small";
    ThemeShadowSizes["NORMAL"] = "normal";
    ThemeShadowSizes["BIG"] = "big";
    ThemeShadowSizes["HUGE"] = "huge";
})(ThemeShadowSizes || (ThemeShadowSizes = {}));
/**
 *
 */
export var ThemeAnimations;
(function (ThemeAnimations) {
    ThemeAnimations["GROW_IN"] = "grow-in";
    ThemeAnimations["GROW_IN_OUT_REPEAT"] = "grow-in-out-repeat";
    ThemeAnimations["SLIDE_IN_LEFT"] = "slide-in-left";
    ThemeAnimations["SLIDE_IN_RIGHT"] = "slide-in-right";
    ThemeAnimations["SLIDE_FADE_IN_RIGHT"] = "slide-fade-in-right";
})(ThemeAnimations || (ThemeAnimations = {}));
